function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "seed-list_svg__Ellipse_728",
  width: 11,
  height: 11,
  x: 6,
  y: 14,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.502
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "seed-list_svg__Ellipse_789",
  width: 11,
  height: 11,
  x: 18,
  y: 14,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-2",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.502
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-2",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "seed-list_svg__Line_546",
  width: 7,
  height: 11,
  x: 8,
  y: 8.5,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-3",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.502
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-3",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "seed-list_svg__Ellipse_787",
  width: 11,
  height: 11,
  x: 12,
  y: 0,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-4",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.502
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-4",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "seed-list_svg__Ellipse_725",
  width: 23,
  height: 23,
  x: 0,
  y: 4,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-5",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.502
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-5",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "seed-list_svg__Line_547",
  width: 7,
  height: 12,
  x: 14,
  y: 5.5,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-6",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.502
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-6",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "seed-list_svg__Line_548",
  width: 7,
  height: 12,
  x: 20,
  y: 7.5,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-7",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.502
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-7",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "seed-list_svg__Ellipse_729",
  width: 11,
  height: 11,
  x: 12,
  y: 7,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-8",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.502
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-8",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "seed-list_svg__Ellipse_788",
  width: 23,
  height: 23,
  x: 12,
  y: 4,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-9",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.502
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-9",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".seed-list_svg__cls-1,.seed-list_svg__cls-2,.seed-list_svg__cls-5{fill:none}.seed-list_svg__cls-1,.seed-list_svg__cls-2{stroke:#23d3cd}.seed-list_svg__cls-2{stroke-dasharray:1 1}.seed-list_svg__cls-3{fill:#23d3cd}.seed-list_svg__cls-4{stroke:none}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "seed-list_svg__Component_113_168",
  transform: "translate(9 3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "seed-list_svg__Group_21782",
  transform: "rotate(-90 718.5 1081.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "seed-list_svg__Group_22220"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#seed-list_svg__Ellipse_728)",
  transform: "rotate(90 724.5 1078.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "seed-list_svg__Ellipse_728-2",
  className: "seed-list_svg__cls-1",
  transform: "rotate(90 -1.5 15.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list_svg__cls-4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2,
  className: "seed-list_svg__cls-5"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#seed-list_svg__Ellipse_789)",
  transform: "rotate(90 724.5 1078.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "seed-list_svg__Ellipse_789-2",
  className: "seed-list_svg__cls-1",
  transform: "rotate(90 4.5 21.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list_svg__cls-4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2,
  className: "seed-list_svg__cls-5"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#seed-list_svg__Line_546)",
  transform: "rotate(90 724.5 1078.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "seed-list_svg__Line_546-2",
  d: "M5 0H0",
  className: "seed-list_svg__cls-2",
  transform: "rotate(90 0 11.5)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#seed-list_svg__Ellipse_787)",
  transform: "rotate(90 724.5 1078.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "seed-list_svg__Ellipse_787-2",
  className: "seed-list_svg__cls-1",
  transform: "rotate(-90 11.5 -3.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list_svg__cls-4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2,
  className: "seed-list_svg__cls-5"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#seed-list_svg__Ellipse_725)",
  transform: "rotate(90 724.5 1078.5)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "seed-list_svg__Ellipse_725-2",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list_svg__cls-3",
  transform: "rotate(90 2 12)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#seed-list_svg__Line_547)",
  transform: "rotate(90 724.5 1078.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "seed-list_svg__Line_547-2",
  d: "M0 0h6",
  className: "seed-list_svg__cls-2",
  transform: "rotate(90 4.5 13)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#seed-list_svg__Line_548)",
  transform: "rotate(90 724.5 1078.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "seed-list_svg__Line_548-2",
  d: "M6 0H0",
  className: "seed-list_svg__cls-2",
  transform: "rotate(90 6.5 17)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#seed-list_svg__Ellipse_729)",
  transform: "rotate(90 724.5 1078.5)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "seed-list_svg__Ellipse_729-2",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list_svg__cls-3",
  transform: "rotate(-90 15 0)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#seed-list_svg__Ellipse_788)",
  transform: "rotate(90 724.5 1078.5)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "seed-list_svg__Ellipse_788-2",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list_svg__cls-3",
  transform: "rotate(90 8 18)"
})))));
function SvgSeedList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 27,
    viewBox: "0 0 35 27"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='35' height='27' viewBox='0 0 35 27'%3e %3cdefs%3e %3cfilter id='Ellipse_728' width='11' height='11' x='6' y='14' filterUnits='userSpaceOnUse'%3e %3cfeOffset/%3e %3cfeGaussianBlur result='blur' stdDeviation='1'/%3e %3cfeFlood flood-opacity='.502'/%3e %3cfeComposite in2='blur' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Ellipse_789' width='11' height='11' x='18' y='14' filterUnits='userSpaceOnUse'%3e %3cfeOffset/%3e %3cfeGaussianBlur result='blur-2' stdDeviation='1'/%3e %3cfeFlood flood-opacity='.502'/%3e %3cfeComposite in2='blur-2' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Line_546' width='7' height='11' x='8' y='8.5' filterUnits='userSpaceOnUse'%3e %3cfeOffset/%3e %3cfeGaussianBlur result='blur-3' stdDeviation='1'/%3e %3cfeFlood flood-opacity='.502'/%3e %3cfeComposite in2='blur-3' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Ellipse_787' width='11' height='11' x='12' y='0' filterUnits='userSpaceOnUse'%3e %3cfeOffset/%3e %3cfeGaussianBlur result='blur-4' stdDeviation='1'/%3e %3cfeFlood flood-opacity='.502'/%3e %3cfeComposite in2='blur-4' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Ellipse_725' width='23' height='23' x='0' y='4' filterUnits='userSpaceOnUse'%3e %3cfeOffset dy='3'/%3e %3cfeGaussianBlur result='blur-5' stdDeviation='3'/%3e %3cfeFlood flood-opacity='.502'/%3e %3cfeComposite in2='blur-5' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Line_547' width='7' height='12' x='14' y='5.5' filterUnits='userSpaceOnUse'%3e %3cfeOffset/%3e %3cfeGaussianBlur result='blur-6' stdDeviation='1'/%3e %3cfeFlood flood-opacity='.502'/%3e %3cfeComposite in2='blur-6' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Line_548' width='7' height='12' x='20' y='7.5' filterUnits='userSpaceOnUse'%3e %3cfeOffset/%3e %3cfeGaussianBlur result='blur-7' stdDeviation='1'/%3e %3cfeFlood flood-opacity='.502'/%3e %3cfeComposite in2='blur-7' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Ellipse_729' width='11' height='11' x='12' y='7' filterUnits='userSpaceOnUse'%3e %3cfeOffset/%3e %3cfeGaussianBlur result='blur-8' stdDeviation='1'/%3e %3cfeFlood flood-opacity='.502'/%3e %3cfeComposite in2='blur-8' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cfilter id='Ellipse_788' width='23' height='23' x='12' y='4' filterUnits='userSpaceOnUse'%3e %3cfeOffset dy='3'/%3e %3cfeGaussianBlur result='blur-9' stdDeviation='3'/%3e %3cfeFlood flood-opacity='.502'/%3e %3cfeComposite in2='blur-9' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cstyle%3e .cls-1,.cls-2,.cls-5%7bfill:none%7d.cls-1,.cls-2%7bstroke:%2323d3cd%7d.cls-2%7bstroke-dasharray:1 1%7d.cls-3%7bfill:%2323d3cd%7d.cls-4%7bstroke:none%7d %3c/style%3e %3c/defs%3e %3cg id='Component_113_168' transform='translate(9 3)'%3e %3cg id='Group_21782' transform='rotate(-90 718.5 1081.5)'%3e %3cg id='Group_22220'%3e %3cg filter='url(%23Ellipse_728)' transform='rotate(90 724.5 1078.5)'%3e %3cg id='Ellipse_728-2' class='cls-1' transform='rotate(90 -1.5 15.5)'%3e %3ccircle cx='2.5' cy='2.5' r='2.5' class='cls-4'/%3e %3ccircle cx='2.5' cy='2.5' r='2' class='cls-5'/%3e %3c/g%3e %3c/g%3e %3cg filter='url(%23Ellipse_789)' transform='rotate(90 724.5 1078.5)'%3e %3cg id='Ellipse_789-2' class='cls-1' transform='rotate(90 4.5 21.5)'%3e %3ccircle cx='2.5' cy='2.5' r='2.5' class='cls-4'/%3e %3ccircle cx='2.5' cy='2.5' r='2' class='cls-5'/%3e %3c/g%3e %3c/g%3e %3cg filter='url(%23Line_546)' transform='rotate(90 724.5 1078.5)'%3e %3cpath id='Line_546-2' d='M5 0L0 0' class='cls-2' transform='rotate(90 0 11.5)'/%3e %3c/g%3e %3cg filter='url(%23Ellipse_787)' transform='rotate(90 724.5 1078.5)'%3e %3cg id='Ellipse_787-2' class='cls-1' transform='rotate(-90 11.5 -3.5)'%3e %3ccircle cx='2.5' cy='2.5' r='2.5' class='cls-4'/%3e %3ccircle cx='2.5' cy='2.5' r='2' class='cls-5'/%3e %3c/g%3e %3c/g%3e %3cg filter='url(%23Ellipse_725)' transform='rotate(90 724.5 1078.5)'%3e %3ccircle id='Ellipse_725-2' cx='2.5' cy='2.5' r='2.5' class='cls-3' transform='rotate(90 2 12)'/%3e %3c/g%3e %3cg filter='url(%23Line_547)' transform='rotate(90 724.5 1078.5)'%3e %3cpath id='Line_547-2' d='M0 0L6 0' class='cls-2' transform='rotate(90 4.5 13)'/%3e %3c/g%3e %3cg filter='url(%23Line_548)' transform='rotate(90 724.5 1078.5)'%3e %3cpath id='Line_548-2' d='M6 0L0 0' class='cls-2' transform='rotate(90 6.5 17)'/%3e %3c/g%3e %3cg filter='url(%23Ellipse_729)' transform='rotate(90 724.5 1078.5)'%3e %3ccircle id='Ellipse_729-2' cx='2.5' cy='2.5' r='2.5' class='cls-3' transform='rotate(-90 15 0)'/%3e %3c/g%3e %3cg filter='url(%23Ellipse_788)' transform='rotate(90 724.5 1078.5)'%3e %3ccircle id='Ellipse_788-2' cx='2.5' cy='2.5' r='2.5' class='cls-3' transform='rotate(90 8 18)'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgSeedList as ReactComponent };